import { setSnackbarNotify } from 'redux/slices/modals/modals.slice';

export const handleSnackbarNotify = (dispatch: any, message: string, severity: string) => {
  dispatch(
    setSnackbarNotify({
      open: true,
      message,
      severity,
    }),
  );
};
